import { Grid, useMediaQuery } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'

import { CARD_VARIANT } from 'src/common/components/card/constants'
import { getCardDate } from 'src/common/utils/js/getCardDate'
import { CARD_ALIGNMENT } from 'src/components/card-carousel/constants'
import theme from 'src/styles/theme'

export default function GridView(props) {
  const { data, cardAlignment, card, content_type_mode } = props
  if (!data || !Array.isArray(data) || data.length === 0) return null

  const lgUp = useMediaQuery(() => theme.breakpoints.up('lg'))
  const xlUp = useMediaQuery(() => theme.breakpoints.up('xl'))

  const layoutCard = (cardData, variantCard, gaTag, index) => {
    if (content_type_mode === 'manual') {
      if (!card || !card[index]) return null

      const cardElement = cardData?.card || card[index]

      if (!React.isValidElement(cardElement)) {
        console.error('Invalid React element:', cardElement)
        return null // Return null if it's not a valid React element
      }

      // Clone the valid React element with new props for 'manual' mode
      return React.cloneElement(cardElement, {
        variant: variantCard,
        cardData: {
          title: cardData?.Heading,
          description: cardData?.Sub_heading,
          tag: cardData.tag,
          image: {
            url: cardData?.image?.url,
            alt: cardData?.image?.alt,
          },
          link: {
            url: cardData?.card_url,
            title: cardData?.default_text,
          },
          date: {
            ...getCardDate(cardData),
            time: cardData?.event_start_time,
          },
          iconCalender: cardData?.recurring_event,
          trail: {
            length:
              cardData?.trail_length_mile && cardData?.trail_length_km
                ? `${cardData?.trail_length_mile} mile (${cardData?.trail_length_km} km)`
                : undefined,
            activityLevel: cardData?.activity_level,
          },
        },
        gaTag,
      })
    }

    // Default logic when content_type_mode is 'automatic'
    const defaultCardElement = cardData?.card || card
    return React.cloneElement(defaultCardElement, {
      variant: variantCard,
      cardData: {
        title: cardData?.Heading,
        description: cardData?.Sub_heading,
        image: {
          url: cardData?.image?.url,
          alt: cardData?.image?.alt,
        },
        link: {
          url: cardData?.card_url,
          title: cardData?.default_text,
        },
        date: {
          ...getCardDate(cardData),
          time: cardData?.event_start_time,
        },
        iconCalender: cardData?.recurring_event,
        trail: {
          length:
            cardData?.trail_length_mile && cardData?.trail_length_km
              ? `${cardData?.trail_length_mile} mile (${cardData?.trail_length_km} km)`
              : undefined,
          activityLevel: cardData?.activity_level,
        },
      },
      gaTag,
    })
  }

  const layoutGrid = () => {
    if (
      !xlUp &&
      (cardAlignment === CARD_ALIGNMENT.HORIZONTAL || data.length === 1)
    ) {
      return data.map((item, i) => (
        <Grid item xs={12} key={i}>
          {layoutCard(item, CARD_VARIANT.HORIZONTAL, `carousel_${i + 1}`, i)}
        </Grid>
      ))
    }

    if (xlUp) {
      if (cardAlignment === CARD_ALIGNMENT.VERTICAL) {
        if (data.length === 3) {
          return data.map((item, i) => (
            <Grid item md={4} key={i}>
              {layoutCard(
                item,
                CARD_VARIANT.VERTICAL_WIDE,
                `carousel_${i + 1}`,
                i
              )}
            </Grid>
          ))
        }

        return data.map((item, i) => (
          <Grid item md={6} key={i}>
            {layoutCard(item, CARD_VARIANT.FEATURE, `carousel_${i + 1}`, i)}
          </Grid>
        ))
      }

      return data.map((item, i) => (
        <Grid item md={6} key={i}>
          {layoutCard(item, CARD_VARIANT.HORIZONTAL, `carousel_${i + 1}`, i)}
        </Grid>
      ))
    }

    if (lgUp) {
      if (cardAlignment === CARD_ALIGNMENT.VERTICAL) {
        if (data.length === 3) {
          return data.map((item, i) => (
            <Grid item md={4} key={i}>
              {layoutCard(item, CARD_VARIANT.VERTICAL, `carousel_${i + 1}`, i)}
            </Grid>
          ))
        }
      }
    }

    return data.map((item, i) => (
      <Grid item md={6} key={i}>
        {layoutCard(item, CARD_VARIANT.VERTICAL_WIDE, `carousel_${i + 1}`, i)}
      </Grid>
    ))
  }

  return (
    <Grid container spacing={2}>
      {layoutGrid()}
    </Grid>
  )
}

GridView.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      default_text: PropTypes.string,
      card_url: PropTypes.string,
      Heading: PropTypes.string,
      Sub_heading: PropTypes.string,
      image: PropTypes.shape({
        url: PropTypes.string,
        alt: PropTypes.string,
      }),
    })
  ),
}
